export enum CollectorRouteName {
    Index = 'collectors.index',
    Create = 'collectors.create',
    Edit = 'collectors.edit',
}

export default {
    path: 'collectors',
    name: CollectorRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Collectors',
        icon: 'fal fa-album-collection fa-fw',
        location: 'sidebar',
        permission: 'manage-datum',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: CollectorRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Collector',
                permission: 'manage-datum',
                group: 'main',
            },
        },
        {
            path: ':collectorId/edit',
            name: CollectorRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Collector',
                permission: 'manage-datum',
                group: 'main',
            },
        },
    ],
}
